// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * What a `Blob` holds once inflated.
 */
export enum BlobKind {
  Unspecified = 0,
  IdlText = 1,
  EventsXml = 2,
  TranslationTable = 3,
  MappingOverrides = 4,
}
